// extracted by mini-css-extract-plugin
export default {"pagination":"s_pagination__ZrQaN","arrowLink":"s_arrowLink__wgkpe","pageLink":"s_pageLink__SIsA5","pageLinkActive":"s_pageLinkActive__yQgT5"};